import { render } from "./tabs-approval.vue?vue&type=template&id=d26f3a1e&ts=true"
import script from "./tabs-approval.vue?vue&type=script&lang=ts"
export * from "./tabs-approval.vue?vue&type=script&lang=ts"

import "./tabs-approval.vue?vue&type=style&index=0&id=d26f3a1e&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__